import { render, staticRenderFns } from "./PriceSummaryToggle.vue?vue&type=template&id=48cbe91f&"
import script from "./PriceSummaryToggle.vue?vue&type=script&lang=js&"
export * from "./PriceSummaryToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports